<template>
  <div v-if="show" class="odp_model">
    <template v-for="(item, index) in table">
      <o-vData
        v-if="item['data']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
      <o-vDataMulti
        v-else-if="item['data_multi']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
      <o-vDataAfter
        v-else-if="item['data_after']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
    </template>
  </div>
</template>
<script>
import { gain_produce } from "@/seal/proCardSet";

export default {
  name: "fangkatao", //专版房卡套
  components: {},
  props: {},
  data() {
    return {
      pid: "pidcards_hbfkt",
      show: false,
      table: {},
    };
  },
  methods: {
    showChange() {
      // 获取表单
      const produce = gain_produce(this["pid"]);
      if (produce["table"]) {
        this.table = produce["table"];
      } else {
        return;
      }

      this.show = true;
    },
    closeChange() {
      this.show = false;
    },
    //输入框完成事件
    inputChange(event) {
      const params = this.func_tidyParams();
      let pid = "";
      if (params.string.indexOf("合版房卡套") >= 0 && params.qid !== 21) {
        pid = "pidcards_hbfkt";
      } else {
        pid = "pidcards_zbfkt";
      }
      this.$parent.func_quotation(pid, params);
    },
    //点击产品规格-汇总
    func_SPEC_S(event) {
      const type = event.currentTarget.dataset.type;
      const index = event.currentTarget.dataset.index;
      const seq = event.currentTarget.dataset.seq;
      if (!this.table[index] || !this.table[index][type]) return;
      switch (type) {
        case "data": {
          //当前点击行的所有参数规格
          let data = this.table[index][type];
          if (data[seq]["choose"] && data[seq]["type"] !== "select") return;

          // 点击区域属-'下拉框'
          if (data[seq]["type"] === "select") {
            const select_index = event.currentTarget.dataset.select_index;
            if (select_index) {
              data[seq]["name"] =
                data[seq]["select_data"][select_index]["name"];
              data[seq]["value"] =
                data[seq]["select_data"][select_index]["value"];
            }
          }

          // 切换已选中的'下拉框'的内容时-不需要执行
          if (!data[seq]["choose"]) {
            for (let i in data) {
              if (data[i]["choose"]) {
                data[i]["choose"] = false;
                data[seq]["choose"] = true;
                // 另行处理

                if (index === "p_chicun") {
                  // 成品尺寸-开口式没有'单面'
                  this.table["p_daomo"]["data"] = [
                    {
                      type: "default",
                      name: "标准刀模",
                      value: "0",
                      choose: true,
                    },
                  ];
                  if (
                    //口袋式，专版
                    data[0]["choose"] &&
                    this.table["p_leixing"]["data"][1].choose
                  ) {
                    this.table["p_houdaogongxu"]["data_after"][2].container =
                      "hjg";
                    this.table["p_houdaogongxu"]["data_after"][2].data = [
                      {
                        type: "select",
                        name: "单面哑膜",
                        value: "单面覆哑膜",
                        choose: true,
                        select_show: false,
                        select_data: [
                          { name: "单面亮膜", value: "单面覆亮膜" },
                          { name: "单面哑膜", value: "单面覆哑膜" },
                          { name: "单面过光油", value: "单面过光油" },
                          { name: "单面防刮花哑膜", value: "31687" },
                          // { name: "单面过哑油", value: "单面过哑油" },
                        ],
                      },
                    ];
                  } else if (
                    //对折式，合版
                    data[1]["choose"] &&
                    this.table["p_leixing"]["data"][0].choose
                  ) {
                    this.table["p_houdaogongxu"].data_after = [
                      {
                        container: "hjg",
                        must: true,
                        reduce: true,
                        data: [
                          {
                            type: "default",
                            name: "模切",
                            value: "模切",
                            choose: true,
                          },
                        ],
                      },
                      {
                        container: "hjg",
                        must: true,
                        reduce: true,
                        data: [
                          {
                            type: "default",
                            name: "粘成品",
                            value: "切圆角",
                            choose: true,
                          },
                        ],
                      },
                      {
                        container: "hjg",
                        must: true,
                        data: [
                          {
                            type: "select",
                            name: "单面哑膜",
                            value: "单面覆哑膜",
                            choose: true,
                            select_show: false,
                            select_data: [
                              { name: "单面哑膜", value: "单面覆哑膜" },
                            ],
                          },
                        ],
                      },
                    ];
                  }
                  if (
                    //口袋式
                    data[0]["choose"] &&
                    this.table["p_danshuangmian"]["data"].length > 1
                  ) {
                    this.table["p_danshuangmian"]["data"] = [
                      {
                        type: "default",
                        name: "单面",
                        value: "1",
                        choose: true,
                      },
                    ];
                    this.table["p_chengpinchicun"]["data"] = [
                      {
                        type: "default",
                        name: "直角62*95mm",
                        value: [139, 110, "139*110", "口袋式直角62*92mm"],
                        choose: true,
                      },
                      {
                        type: "default",
                        name: "异形62*95mm",
                        value: [139, 110, "139*110", "口袋式异形62*92mm"],
                        choose: false,
                      },
                      {
                        type: "custom2",
                        name: "自定义展开尺寸",
                        value: [139, 110, "139*110", "展开尺寸:139×110"],
                        choose: false,
                      },
                    ];
                  } else if (
                    //对折式
                    data[1]["choose"] &&
                    this.table["p_danshuangmian"]["data"].length < 2
                  ) {
                    this.table["p_danshuangmian"]["data"] = [
                      {
                        type: "default",
                        name: "双面",
                        value: "2",
                        choose: true,
                      },
                      {
                        type: "default",
                        name: "单面",
                        value: "1",
                        choose: false,
                      },
                    ];
                    this.table["p_chengpinchicun"]["data"] = [
                      {
                        type: "default",
                        name: "标准62*95mm",
                        value: [
                          139,
                          110,
                          "对折式标准62*92mm",
                          "对折式标准62*92mm",
                        ],
                        choose: true,
                      },
                      {
                        type: "default",
                        name: "大号75*115mm",
                        value: [
                          165,
                          153,
                          "对折式大号70*115mm",
                          "对折式大号70*115mm",
                        ],
                        choose: false,
                      },
                      {
                        type: "custom2",
                        name: "自定义展开尺寸",
                        value: [139, 123, "139*123", "展开尺寸:139×123"],
                        choose: false,
                      },
                    ];
                  }
                  if (data[0].choose) {
                    //口袋式
                    if (this.table.p_leixing["data"][0].choose) {
                      this.table["p_houdaogongxu"]["data_after"].splice(1, 1, {
                        container: "hjg",
                        must: true,
                        reduce: true,
                        data: [
                          {
                            type: "default",
                            name: "粘成品",
                            value: "切圆角",
                            choose: true,
                          },
                        ],
                      });
                    }
                    if (
                      this.table["p_houdaogongxu"]["data_after"].length == 8
                    ) {
                      this.table["p_houdaogongxu"]["data_after"].splice(2, 1);
                    }

                    if (this.table.p_leixing.data[1].choose) {
                      this.table["p_houdaogongxu"]["data_after"][2].container =
                        "hjg";
                      this.table["p_houdaogongxu"]["data_after"][2].data = [
                        {
                          type: "select",
                          name: "单面哑膜",
                          value: "单面覆哑膜",
                          choose: true,
                          select_show: false,
                          select_data: [
                            { name: "单面亮膜", value: "单面覆亮膜" },
                            { name: "单面哑膜", value: "单面覆哑膜" },
                            { name: "单面过光油", value: "单面过光油" },
                            { name: "单面防刮花哑膜", value: "31687" },
                            // { name: "单面过哑油", value: "单面过哑油" },
                          ],
                        },
                      ];
                    }
                  } else if (
                    //对折式，标准刀模   单张报价
                    data[1].choose &&
                    !this.table.p_daomo["data"][0].choose
                  ) {
                    this.table["p_houdaogongxu"]["data_after"].splice(1, 1, {
                      container: "hjgzdy8",
                      must: false,
                      data: [
                        {
                          type: "default",
                          name: "粘成品",
                          value: "15526",
                          choose: true,
                        },
                      ],
                    });
                    this.table["p_houdaogongxu"]["data_after"].splice(2, 0, {
                      container: "hjgzdy9",
                      must: false,
                      data: [
                        {
                          type: "default",
                          name: "粘双底兜",
                          value: "15399",
                          choose: false,
                        },
                      ],
                    });
                  } else if (
                    //对折式，标准刀模，单张报价
                    data[1].choose &&
                    this.table.p_daomo["data"][0].choose &&
                    this.table.p_leixing["data"][1].choose
                  ) {
                    this.table["p_houdaogongxu"]["data_after"].splice(1, 1, {
                      container: "hjgzdy8",
                      must: false,
                      reduce: true,
                      data: [
                        {
                          type: "default",
                          name: "粘成品",
                          value: "15526",
                          choose: true,
                        },
                      ],
                    });
                    if (
                      this.table["p_houdaogongxu"]["data_after"].length == 8
                    ) {
                      this.table["p_houdaogongxu"]["data_after"].splice(2, 1);
                    }
                  }
                }
                if (index === "p_chengpinchicun") {
                  if (data[2]["choose"]) {
                    console.log("自定义尺寸");
                    this.table["p_daomo"]["data"] = [
                      {
                        type: "default",
                        name: "定制刀模",
                        value: "1",
                        choose: true,
                      },
                    ];
                    if (
                      this.table.p_chicun["data"][1].choose &&
                      this.table.p_leixing["data"][0].choose
                    ) {
                      console.log("自定义尺寸对折式");
                      this.table["p_houdaogongxu"]["data_after"].splice(1, 1, {
                        container: "hjg",
                        must: false,
                        data: [
                          {
                            type: "default",
                            name: "粘成品",
                            value: "切圆角",
                            choose: true,
                          },
                        ],
                      });
                      console.log("wwwww");
                    } else if (this.table.p_leixing["data"][1].choose) {
                      console.log(22);
                      //单张报价，专版  口袋式
                      this.table["p_houdaogongxu"]["data_after"].splice(1, 1, {
                        container: "hjgzdy8",
                        must: true,
                        reduce: true,
                        data: [
                          {
                            type: "default",
                            name: "粘成品",
                            value: "15526",
                            choose: true,
                          },
                        ],
                      });
                      if (this.table["p_chicun"]["data"][1].choose) {
                        console.log("nnnnnn");
                        //单张
                        this.table["p_houdaogongxu"]["data_after"].splice(
                          1,
                          1,
                          {
                            name: "粘",
                            container: "ndd",
                            must: true,
                            data: [
                              {
                                type: "default",
                                name: "粘单兜",
                                value: "15526",
                                choose: true,
                              },
                              {
                                type: "default",
                                name: "粘双兜",
                                value: "15527",
                                choose: false,
                              },
                            ],
                          }
                        );
                      }
                    }
                  } else {
                    this.table["p_daomo"]["data"] = [
                      {
                        type: "default",
                        name: "标准刀模",
                        value: "0",
                        choose: true,
                      },
                    ];
                    console.log(33);
                    if (this.table.p_leixing["data"][0].choose) {
                      this.table["p_houdaogongxu"]["data_after"].splice(1, 1, {
                        container: "hjg",
                        must: false,
                        reduce: true,
                        data: [
                          {
                            type: "default",
                            name: "粘成品",
                            value: "切圆角",
                            choose: true,
                          },
                        ],
                      });
                    } else {
                      this.table["p_houdaogongxu"]["data_after"].splice(1, 1, {
                        container: "hjgzdy8",
                        must: true,
                        reduce: true,
                        data: [
                          {
                            type: "default",
                            name: "粘成品",
                            value: "15526",
                            choose: true,
                          },
                        ],
                      });
                    }
                  }
                }
                if (index == "p_daomo") {
                  if (data[0]["choose"]) {
                    console.log(44);
                    this.table["p_houdaogongxu"]["data_after"].splice(1, 1, {
                      container: "hjgzdy8",
                      must: false,
                      reduce: true,
                      data: [
                        {
                          type: "default",
                          name: "粘成品",
                          value: "15526",
                          choose: true,
                        },
                      ],
                    });

                    if (
                      this.table["p_houdaogongxu"]["data_after"].length == 8
                    ) {
                      this.table["p_houdaogongxu"]["data_after"].splice(2, 1);
                    }
                  } else if (
                    data[1].choose &&
                    this.table.p_chicun["data"][1].choose &&
                    this.table.p_houdaogongxu.data_after.length == 3
                  ) {
                    this.table["p_houdaogongxu"]["data_after"].splice(2, 0, {
                      container: "hjgzdy9",
                      must: false,
                      data: [
                        {
                          type: "default",
                          name: "粘双底兜",
                          value: "15527",
                          choose: false,
                        },
                      ],
                    });
                  }
                }
                if (index == "p_leixing") {
                  if (data[0]["choose"]) {
                    //合版
                    this.table["p_cailiao"].data_multi = [
                      {
                        type: "select",
                        name: "单铜纸(白卡)",
                        value: "2",
                        choose: true,
                        level: "1",
                        select_show: false,
                        select_data: [
                          { name: "单铜纸(白卡)", value: "2" },
                          { name: "双铜纸", value: "1" },
                        ],
                      },
                      {
                        type: "select",
                        name: "250克",
                        value: 250,
                        choose: true,
                        level: "2",
                        select_show: false,
                        select_data: [{ name: "250克", value: 250 }],
                      },
                    ];
                    this.table["p_cailiao"].multi_list = [
                      // 单铜纸
                      [{ name: "250克", value: 250 }],
                      // 双铜纸
                      [{ name: "300克", value: 300 }],
                    ];
                    this.table["p_yinshuayanse"].data = [
                      {
                        type: "default",
                        name: "彩色",
                        value: "4",
                        choose: true,
                      },
                    ];
                    this.table["p_houdaogongxu"].data_after = [
                      {
                        container: "hjg",
                        must: true,
                        reduce: true,
                        data: [
                          {
                            type: "default",
                            name: "模切",
                            value: "模切",
                            choose: true,
                          },
                        ],
                      },
                      {
                        container: "hjg",
                        must: true,
                        reduce: true,
                        data: [
                          {
                            type: "default",
                            name: "粘成品",
                            value: "切圆角",
                            choose: true,
                          },
                        ],
                      },
                      {
                        container: "hjg",
                        must: true,
                        data: [
                          {
                            type: "select",
                            name: "单面哑膜",
                            value: "覆哑膜",
                            choose: true,
                            select_show: false,
                            select_data: [
                              { name: "单面哑膜", value: "覆哑膜" },
                            ],
                          },
                        ],
                      },
                      // {
                      //   container: "hjg",
                      //   must: false,
                      //   reduce: true,
                      //   data: [
                      //     {
                      //       type: "default",
                      //       name: "击凸",
                      //       value: "击凸",
                      //       choose: false,
                      //     },
                      //   ],
                      // },
                      // {
                      //   container: "hjg",
                      //   must: false,
                      //   reduce: true,
                      //   data: [
                      //     {
                      //       type: "default",
                      //       name: "压纹",
                      //       value: "压线",
                      //       choose: false,
                      //     },
                      //   ],
                      // },
                      // {
                      //   container: "hjg",
                      //   must: false,
                      //   reduce: true,
                      //   data: [
                      //     {
                      //       type: "default",
                      //       name: "局部UV",
                      //       value: "UV丝印",
                      //       choose: false,
                      //     },
                      //   ],
                      // },
                    ];
                  } else {
                    //专版
                    this.table.p_chicun.data[0].choose = true;
                    this.table.p_chicun.data[1].choose = false;
                    this.table["p_danshuangmian"]["data"] = [
                      {
                        type: "default",
                        name: "单面",
                        value: "1",
                        choose: true,
                      },
                    ];
                    this.table["p_chengpinchicun"]["data"] = [
                      {
                        type: "default",
                        name: "直角62*95mm",
                        value: [139, 110, "139*110", "口袋式直角62*92mm"],
                        choose: true,
                      },
                      {
                        type: "default",
                        name: "异形62*95mm",
                        value: [139, 110, "139*110", "口袋式异形62*92mm"],
                        choose: false,
                      },
                      {
                        type: "custom2",
                        name: "自定义展开尺寸",
                        value: [139, 110, "139*110", "展开尺寸:139×110"],
                        choose: false,
                      },
                    ];
                    this.table["p_cailiao"].data_multi = [
                      {
                        type: "select",
                        name: "单铜纸(白卡)",
                        value: "2",
                        choose: true,
                        level: "1",
                        select_show: false,
                        select_data: [
                          { name: "双铜纸", value: "1" },
                          { name: "单铜纸(白卡)", value: "2" },
                          { name: "双胶纸", value: "5" },
                          { name: "白牛皮", value: "14" },
                        ],
                      },
                      {
                        type: "select",
                        name: "250克",
                        value: 250,
                        choose: true,
                        level: "2",
                        select_show: false,
                        select_data: [
                          { name: "250克", value: 250 },
                          { name: "210克", value: 210 },
                          { name: "300克", value: 300 },
                          { name: "350克", value: 350 },
                        ],
                      },
                    ];
                    this.table["p_cailiao"].multi_list = [
                      // 双铜纸
                      [
                        { name: "300克", value: 300 },
                        { name: "157克", value: 157 },
                        { name: "200克", value: 200 },
                        { name: "250克", value: 250 },
                        { name: "350克", value: 350 },
                      ],
                      // 单铜纸
                      [
                        { name: "250克", value: 250 },
                        { name: "210克", value: 210 },
                        { name: "300克", value: 300 },
                        { name: "350克", value: 350 },
                      ],
                      // 双胶纸
                      [
                        { name: "100克", value: 100 },
                        { name: "120克", value: 120 },
                        { name: "140克", value: 140 },
                        { name: "160克", value: 160 },
                        { name: "200克", value: 200 },
                        { name: "250克", value: 250 },
                      ],
                      // 白牛皮
                      [
                        { name: "120克", value: 120 },
                        { name: "140克", value: 140 },
                        { name: "160克", value: 160 },
                        { name: "180克", value: 180 },
                        { name: "200克", value: 200 },
                        { name: "230克", value: 230 },
                        { name: "250克", value: 250 },
                        { name: "300克", value: 300 },
                      ],
                    ];
                    this.table["p_yinshuayanse"].data = [
                      {
                        type: "default",
                        name: "彩色",
                        value: "4",
                        choose: true,
                      },
                      {
                        type: "default",
                        name: "双色",
                        value: "2",
                        choose: false,
                      },
                      {
                        type: "default",
                        name: "单色",
                        value: "1",
                        choose: false,
                      },
                      {
                        type: "default",
                        name: "无",
                        value: "0",
                        choose: false,
                      },
                    ];
                    this.table["p_houdaogongxu"].data_after = [
                      {
                        container: "hjg",
                        must: true,
                        reduce: true,
                        data: [
                          {
                            type: "default",
                            name: "模切",
                            value: "模切",
                            choose: true,
                          },
                        ],
                      },
                      {
                        container: "hjgzdy8",
                        must: true,
                        reduce: true,
                        data: [
                          {
                            type: "default",
                            name: "粘成品",
                            value: "15526",
                            choose: true,
                          },
                        ],
                      },
                      {
                        container: "hjg",
                        must: false,
                        data: [
                          {
                            type: "select",
                            name: "单面哑膜",
                            value: "单面覆哑膜",
                            choose: true,
                            select_show: false,
                            select_data: [
                              { name: "单面亮膜", value: "单面覆亮膜" },
                              { name: "单面哑膜", value: "单面覆哑膜" },
                              { name: "单面过光油", value: "单面过光油" },
                              { name: "单面防刮花哑膜", value: "31687" },
                              // { name: "单面过哑油", value: "单面过哑油" },
                            ],
                          },
                        ],
                      },
                      {
                        container: ["tjx", "tjy", "hjg"],
                        must: false,
                        data: [
                          {
                            type: "select",
                            custom2: true,
                            unit: "mm",
                            name: "烫黄金",
                            value: [10, 10, "烫金"],
                            choose: false,
                            select_show: false,
                            select_data: [
                              { name: "烫黄金", value: [10, 10, "烫金"] },
                              { name: "烫银", value: [10, 10, "烫金"] },
                              { name: "烫红金", value: [10, 10, "烫金"] },
                              { name: "烫哑金", value: [10, 10, "烫金"] },
                              { name: "烫蓝金", value: [10, 10, "烫金"] },
                              { name: "烫黑金", value: [10, 10, "烫金"] },
                              {
                                name: "烫指定颜色金",
                                value: [10, 10, "烫金"],
                              },
                            ],
                          },
                        ],
                      },
                      {
                        container: ["uvx", "uvy", "hjg"],
                        must: false,
                        data: [
                          {
                            type: "custom2",
                            name: "局部UV",
                            value: [10, 10, "局部UV"],
                            choose: false,
                          },
                        ],
                      },
                      {
                        container: "hjg",
                        must: false,
                        data: [
                          {
                            type: "default",
                            name: "压纹",
                            value: "压纹",
                            choose: false,
                          },
                        ],
                      },
                      {
                        container: "hjg",
                        must: false,
                        data: [
                          {
                            type: "default",
                            name: "击凸",
                            value: "击凸",
                            choose: false,
                          },
                        ],
                      },
                    ];
                  }
                }

                if (
                  this.table.p_leixing.data[0].choose //自定义  ，合版
                ) {
                  if (this.table["p_yinshuashuliang"].data.length == 7) {
                    this.table["p_yinshuashuliang"].data = [
                      {
                        type: "default",
                        name: "500",
                        value: 500,
                        choose: true,
                      },
                      {
                        type: "default",
                        name: "1000",
                        value: 1000,
                        choose: false,
                      },
                      {
                        type: "default",
                        name: "2000",
                        value: 2000,
                        choose: false,
                      },
                      {
                        type: "default",
                        name: "3000",
                        value: 3000,
                        choose: false,
                      },
                      {
                        type: "default",
                        name: "5000",
                        value: 5000,
                        choose: false,
                      },
                      {
                        type: "default",
                        name: "10000",
                        value: 10000,
                        choose: false,
                      },
                    ];
                  }
                } else {
                  if (this.table["p_yinshuashuliang"].data.length == 6) {
                    this.table["p_yinshuashuliang"].data = [
                      {
                        type: "default",
                        name: "500",
                        value: 500,
                        choose: true,
                      },
                      {
                        type: "default",
                        name: "1000",
                        value: 1000,
                        choose: false,
                      },
                      {
                        type: "default",
                        name: "2000",
                        value: 2000,
                        choose: false,
                      },
                      {
                        type: "default",
                        name: "3000",
                        value: 3000,
                        choose: false,
                      },
                      {
                        type: "default",
                        name: "5000",
                        value: 5000,
                        choose: false,
                      },
                      {
                        type: "default",
                        name: "10000",
                        value: 10000,
                        choose: false,
                      },
                      {
                        type: "custom1",
                        name: "",
                        value: 20000,
                        choose: false,
                      },
                    ];
                  }
                }
                break;
              }
            }
          }

          break;
        }
        case "data_multi": {
          const level = event.currentTarget.dataset.level;
          const select_index = event.currentTarget.dataset.select_index;
          let data = this.table[index][type];
          if (!level) return;
          data[seq]["name"] = data[seq]["select_data"][select_index]["name"];
          data[seq]["value"] = data[seq]["select_data"][select_index]["value"];
          if (level === "1") {
            // 切换二级内容
            data[1]["select_data"] =
              this.table[index]["multi_list"][select_index];
            data[1]["name"] = data[1]["select_data"][0]["name"];
            data[1]["value"] = data[1]["select_data"][0]["value"];
          }
          break;
        }
        case "data_after": {
          const se = event.currentTarget.dataset.se;
          const select_index = event.currentTarget.dataset.select_index;
          let data = this.table[index][type];
          if (data[seq]["must"] && data[seq]["data"][se]["choose"]) return;

          let in_data = data[seq]["data"];

          if (select_index !== undefined) {
            in_data[se]["name"] =
              in_data[se]["select_data"][select_index]["name"];
            in_data[se]["value"] =
              in_data[se]["select_data"][select_index]["value"];
          }

          if (data[seq]["must"]) {
            // 当前行为-必选
            for (let i in in_data) {
              if (in_data[i]["choose"]) {
                in_data[i]["choose"] = false;
                in_data[se]["choose"] = true;
                break;
              }
            }
          } else {
            // 当前行为-非必选
            if (in_data[se]["choose"] && select_index === undefined) {
              in_data[se]["choose"] = false;
            } else {
              for (let i in in_data) {
                if (in_data[i]["choose"]) {
                  in_data[i]["choose"] = false;
                  break;
                }
              }
              in_data[se]["choose"] = true;
            }
          }

          break;
        }
        default: {
          return;
        }
      }

      // 整合规格参数，请求报价
      let params = this.func_tidyParams();
      let pid = "";
      if (params.string.indexOf("合版房卡套") >= 0 && params.qid !== 21) {
        pid = "pidcards_hbfkt";
      } else {
        pid = "pidcards_zbfkt";
      }
      this.$parent.func_quotation(pid, params);
    },
    // 整理参数
    func_tidyParams() {
      let result = {};
      if (this.table.p_leixing["data"][0].choose) {
        if(this.table.p_chengpinchicun['data'][2].choose){
          result = {
          need_QQoffer: false, //需QQ另行计价
          string: "", //报价内容
          hjg: [],
          SysCode: "Web",
          pid: 3914,
          vid: 0,
          gvip: null,
          p: 0,
          isdiy: 1,
          kuans: 1,
          labelVal: 0,
          prh: 0,
          chichun: 1,
          PSList: 0,
        };
        }else{
          result = {
            need_QQoffer: false, //需QQ另行计价
            string: "标准房卡套-", //报价内容
            hjg: [],
            api: "getprice4A",
          }
        }

      } else {
        result = {
          need_QQoffer: false, //需QQ另行计价
          string: "", //报价内容
          hjg: [],
          SysCode: "Web",
          pid: 3914,
          byx: 2,
          sjlx: 2,
          hjgzdycount: 13,
          hjgother: 1,
          prh: 0,
          chichun2: 50,
          labelVal: 0,
          PSList: 0,
          p: 0,
          jdgs: 10,
          isdiy: 1,
          Printer_Test: 0,
          ZXid: 0,
          jidaohen: 1,
          gvip: null,
          kuans: 1,
          zeye: "对折",
          yhlx: "压痕不折",
          hjghmgs: "1",
          hmjls: 0,
          hjgjjs: 50,
          hjgjjs1: 50,
          materialname: "",
        };
      }
      for (let i in this.table) {
        // 当前行
        const line_name = i;
        // 当前行类型
        let line_type = this.table[i]["data"]
          ? "data"
          : this.table[i]["data_multi"]
          ? "data_multi"
          : this.table[i]["data_after"]
          ? "data_after"
          : false;
        if (!line_type) return;

        const data = this.table[i][line_type];
        switch (line_type) {
          // 面板一(普通)
          case "data": {
            const container = this.table[i]["container"];
            if (!container) return;
            for (let j in data) {
              // 行中选中的块
              if (data[j]["choose"]) {
                // 文字内容提示
                if (line_name === "p_chengpinchicun") {
                  if (this.table.p_chengpinchicun.data[2].choose) {
                    result["string"] +=
                      data[j]["name"] +
                      data[j]["value"][0] +
                      "x" +
                      data[j]["value"][1] +
                      "-";
                  } else {
                    result["string"] += data[j]["name"] + "-";
                  }
                } else if (line_name === "p_yinshuashuliang") {
                  if (this.table.p_leixing.data[0].choose) {
                    result["string"] += data[j]["value"] + "个-";
                  } else {
                    result["string"] += data[j]["value"] + "个-";
                  }
                } else if (line_name === "p_kuanshu") {
                  result["string"] += data[j]["value"] + "款-";
                } else {
                  result["string"] += data[j]["name"] + "-";
                }

                // 常规处理
                if (container.constructor["name"] === "String") {
                  result[container] = data[j]["value"];
                } else if (container.constructor["name"] === "Array") {
                  for (let c in container) {
                    result[container[c]] = data[j]["value"][c];
                  }
                }
                break;
              }
            }
            break;
          }
          // 面板二(多行)
          case "data_multi": {
            const container = this.table[i]["container"];
            if (!container) return;
            for (let c in container) {
              // 文字内容提示
              result["string"] += data[c]["name"] + "-";

              result[container[c]] = data[c]["value"];
            }
            break;
          }
          // 面板二(后道工序)
          case "data_after": {
            for (let j in data) {
              const in_data = data[j]["data"];
              for (let k in in_data) {
                if (in_data[k]["choose"]) {
                  // 文字内容提示
                  if (
                    in_data[k]["name"] === "烫金" ||
                    in_data[k]["name"] === "烫银" ||
                    in_data[k]["name"] === "局部UV" ||
                    in_data[k]["name"].indexOf("击凸") > 0
                  ) {
                    const x = in_data[k]["value"][0];
                    const y = in_data[k]["value"][1];
                    result["string"] += in_data[k]["name"] + x + "×" + y + "-";
                  } else if (
                    in_data[k]["name"].substring(0, 1) === "烫" &&
                    in_data[k]["custom2"]
                  ) {
                    const x = in_data[k]["value"][0];
                    const y = in_data[k]["value"][1];
                    result["string"] += in_data[k]["name"] + x + "×" + y + "-";
                  } else {
                    result["string"] += in_data[k]["name"] + "-";
                  }
                  const container = data[j]["container"];
                  if (!container) return;
                  if (container === "hjg") {
                    result["hjg"].push(in_data[k]["value"]);
                  } else if (container.constructor["name"] === "String") {
                    result[container] = in_data[k]["value"];
                  } else if (container.constructor["name"] === "Array") {
                    for (let c in container) {
                      if (container[c] === "hjg") {
                        result["hjg"].push(in_data[k]["value"][c]);
                      } else {
                        result[container[c]] = in_data[k]["value"][c];
                      }
                    }
                  }
                  break;
                }
              }
            }
            break;
          }
          default:
            return;
        }
      }

      if (result["string"].endsWith("-")) {
        result["string"] = result["string"].substring(
          0,
          result["string"].length - 1
        );
      }
      result.materialname = this.table.p_cailiao.data_multi[0].name;
      console.log(result.hjg);
      if (
        result.string.indexOf("合版房卡套") >= 0 &&
        result.string.indexOf("自定义展开") >= 0
      ) {
        result.qid = 21;
        result.hesu = result.shuliang / 100;
        if (result.cailiao == 2) {
          result.cailiao = 12534;
        } else if (result.cailiao == 1) {
          result.cailiao = 12535;
        }
        result.hjg.push("打孔");
      } else if (
        result.string.indexOf("合版房卡套") >= 0 &&
        result.string.indexOf("自定义展开") < 0
      ) {
        result.qid = 11;
        result.hesu = result.shuliang / 100;
        if (result.cailiao == 2) {
          result.cailiao = 12534;
        } else if (result.cailiao == 1) {
          result.cailiao = 12535;
        }
        result.hjg.push("打孔");
        if (result.hjg[0] == "模切") {
          result.hjg.splice(0, 1);
        }
      } else {
        for (let i in result.hjg) {
          if (result.hjg[i] == "31687") {
            result.hjgzdy11 = "31687";
            delete result.hjg[i];
          }
        }
      }
      if (result.ndd == "15526") {
        result.hjgzdy8 = 15526;
        delete result.ndd;
      } else if (result.ndd == "15527") {
        result.hjgzdy9 = 15527;
        delete result.ndd;
      }
      return result;
    },
  },
  mounted() {},
};
</script>
<style src='@/style/orderProduct.css'></style>




// WEBPACK FOOTER //
// src/pages/order/v2020/fangkatao.vue